<ng-keyboard-shortcuts [shortcuts]="shortcuts" [disabled]="disabled"></ng-keyboard-shortcuts>
